import { apiUc } from '../http';
import ServiceCRUD from './ServiceCRUDFLEXUC';

class RingGroupsService extends ServiceCRUD {
  constructor() {
    super(`/api/grupos-de-toque`);
  }

  /**
   * Busca um grupo de toque pelo ID.
   * @param {string} id - O ID do grupo de toque.
   * @returns {Promise<any>} - A promessa da requisição.
   */
  findById = (id) => {
    return apiUc.get(`${this.path}/${id}`);
  };

  /**
   * Habilita um grupo de toque.
   * @param {string} id - O ID do grupo de toque.
   * @returns {Promise<any>} - A promessa da requisição.
   */
  enable = (id) => {
    return apiUc.patch(`${this.path}/${id}/enable`);
  };

  /**
   * Desabilita um grupo de toque.
   * @param {string} id - O ID do grupo de toque.
   * @returns {Promise<any>} - A promessa da requisição.
   */
  disable = (id) => {
    return apiUc.patch(`${this.path}/${id}/disable`);
  };

  /**
   * Adiciona extensões a um grupo de toque.
   * @param {string} id - O ID do grupo de toque.
   * @param {object} data - Os dados das extensões a serem adicionadas.
   * @returns {Promise<any>} - A promessa da requisição.
   */
  addExtensions = (id, data) => {
    return apiUc.post(`${this.path}/${id}/add-extensions`, data);
  };

  /**
   * Remove extensões de um grupo de toque.
   * @param {string} id - O ID do grupo de toque.
   * @param {object} data - Os dados das extensões a serem removidas.
   * @returns {Promise<any>} - A promessa da requisição.
   */
  removeExtensions = (id, data) => {
    return apiUc.post(`${this.path}/${id}/remove-extensions`, data);
  };
}

export default new RingGroupsService();
